"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SelectOption_component_exports = {};
__export(SelectOption_component_exports, {
  SelectOption: () => SelectOption
});
module.exports = __toCommonJS(SelectOption_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("react");
var import_clsx = __toESM(require("clsx"));
var import_Check = __toESM(require("@greatmindsorg/gmui-icons-lib/dist/Check"));
var import_react2 = require("@floating-ui/react");
var import_Select = require("./Select.component");
const SelectOption = (_a) => {
  var _b = _a, {
    label,
    children,
    onClick,
    disabled = false,
    textColor
  } = _b, props = __objRest(_b, [
    "label",
    "children",
    "onClick",
    "disabled",
    "textColor"
  ]);
  const {
    activeIndex,
    selectedIndex,
    getItemProps,
    handleSelect,
    setLabel,
    moreThanOneChildren,
    singleSelect,
    simpleSelect,
    customSelect
  } = (0, import_react.useContext)(import_Select.SelectContext);
  const { ref, index } = (0, import_react2.useListItem)({ label });
  const isActive = activeIndex === index;
  const isSelected = selectedIndex === index;
  const isChildren = children || label;
  const handleOnClick = onClick || (() => void 0);
  const selectedStyle = isSelected ? "font-bold" : "font-normal";
  (0, import_react.useEffect)(() => {
    if (!moreThanOneChildren || isSelected) {
      setLabel(label);
    }
  }, [isSelected, moreThanOneChildren]);
  const handleClick = (i, child) => {
    if (disabled) return;
    handleOnClick();
    handleSelect(i, child);
    setLabel(label);
  };
  const getButtonClasses = (selectedStyle2) => {
    return (0, import_clsx.default)([
      "flex w-full items-center justify-between border-0 border-b border-solid border-[--color-border-interactive-divider] bg-[--color-bg-interactive-ter] p-4 last:border-b-0 hover:cursor-pointer hover:bg-[--color-bg-interactive-ter-hover] focus:z-10 focus:outline-[--color-border-interactive-focus] text-lg",
      selectedStyle2,
      "select__option"
    ]);
  };
  const renderSelectOptionButton = () => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "button",
    __spreadProps(__spreadValues(__spreadValues({
      type: "button",
      ref,
      role: "option",
      "aria-selected": isActive && isSelected,
      tabIndex: isActive ? 0 : -1,
      className: (0, import_clsx.default)([
        "select__option flex max-w-full flex-col hover:bg-[--color-bg-interactive-ter-hover] focus:outline-[--color-border-interactive-focus]",
        "w-full",
        "border-0",
        {
          "cursor-not-allowed bg-[--color-bg-interactive-disabled] text-[--color-content-interactive-disabled] opacity-50": disabled,
          "bg-[--color-bg-interactive-ter]": !disabled && !isActive,
          "bg-[--color-bg-interactive-ter-pressed]": isActive
        },
        "border-b border-solid border-[--color-border-interactive-divider]"
      ]),
      disabled
    }, getItemProps({
      onClick: () => handleClick(index, isChildren)
    })), props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { className: "relative box-border flex w-full items-center justify-between pl-3", children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "div",
          {
            className: (0, import_clsx.default)(
              "inline-block break-words break-all py-[13.5px] text-left font-primary text-sm",
              selectedStyle
            ),
            style: { color: textColor },
            children: isChildren
          }
        ),
        isSelected && /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "pr-m", "data-testid": "check-icon", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          import_Check.default,
          {
            color: disabled ? "#797F86" : "#09212C",
            title: "Selected",
            iconSize: "m"
          }
        ) })
      ] })
    })
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, { children: singleSelect || simpleSelect || customSelect ? renderSelectOptionButton() : (
    //Atomic Select Option Default
    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
      "button",
      __spreadProps(__spreadValues(__spreadValues({
        type: "button",
        ref,
        role: "option",
        "aria-selected": isActive && isSelected,
        tabIndex: isActive ? 0 : -1,
        className: getButtonClasses(selectedStyle)
      }, getItemProps({
        onClick: () => handleClick(index, isChildren)
      })), props), {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
            "div",
            {
              className: (0, import_clsx.default)([
                `flex grow pr-4 text-left text-base text-[--color-content-interactive-text-value]`,
                selectedStyle
              ]),
              children: isChildren
            }
          ),
          isSelected && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Check.default, { title: "Selected", iconSize: "m" })
        ]
      })
    )
  ) });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  SelectOption
});
//# sourceMappingURL=SelectOption.component.js.map